const Arrow = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
        <path opacity="0.01" d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 -2.7141e-06 20 -1.74846e-06C8.9543 -7.8281e-07 7.8281e-07 8.9543 1.74846e-06 20C2.7141e-06 31.0457 8.95431 40 20 40Z" fill="#EDEDED"/>
        <path d="M25.729 20.155L15.9102 20.155" stroke="black" strokeWidth="1.3" strokeLinecap="round"/>
        <path d="M19.0879 24.2029L15.0039 20.1189L19.0879 16.0349" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

export default Arrow;
